import React, { useState } from 'react';
import { api } from '../services/api';

interface ClientInvitationProps {
  client: any;
  onClose: () => void;
}

const ClientInvitation: React.FC<ClientInvitationProps> = ({ client, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const sendInvitation = async () => {
    setLoading(true);
    
    try {
      // Send invitation using the correct API endpoint
      await api.post('/client-registration/send-invitation', {
        clientId: client.id
      });
      
      setSent(true);
      
    } catch (error) {
      console.error('Error sending invitation:', error);
      alert('Error sending invitation. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ backgroundColor: 'white', padding: '30px', borderRadius: '12px', maxWidth: '500px', width: '90%' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>Invite Client to Portal</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#666' }}>×</button>
        </div>

        {!sent ? (
          <>
            <div style={{ marginBottom: '20px' }}>
              <p style={{ margin: '0 0 10px 0', color: '#374151' }}>
                <strong>Client:</strong> {client.name} ({client.company_name})
              </p>
              <p style={{ margin: '0 0 10px 0', color: '#374151' }}>
                <strong>Email:</strong> {client.email}
              </p>
              <p style={{ margin: '0 0 10px 0', color: '#374151' }}>
                <strong>Devices:</strong> {client.devices?.length || 0} registered
              </p>
            </div>

            <div style={{ backgroundColor: '#f8fafc', padding: '16px', borderRadius: '8px', marginBottom: '20px' }}>
              <h4 style={{ margin: '0 0 8px 0', fontSize: '14px', fontWeight: '600', color: '#1e40af' }}>
                What happens next:
              </h4>
              <p style={{ margin: '0 0 4px 0', fontSize: '14px', color: '#374151' }}>
                📧 <strong>Email:</strong> Secure registration link sent to {client.email}
              </p>
              <p style={{ margin: 0, fontSize: '14px', color: '#374151' }}>
                🔐 <strong>Setup:</strong> Client creates username and password to access portal
              </p>
            </div>

            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
              <button onClick={onClose} className="btn btn-secondary">Cancel</button>
              <button onClick={sendInvitation} className="btn btn-primary" disabled={loading}>
                {loading ? 'Sending...' : 'Send Portal Invitation'}
              </button>
            </div>
          </>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
            <h4 style={{ margin: '0 0 12px 0', color: '#059669' }}>Invitation Sent!</h4>
            <p style={{ margin: '0 0 20px 0', color: '#374151', fontSize: '14px' }}>
              Portal invitation has been sent to {client.email} with registration instructions.
            </p>
            <div style={{ backgroundColor: '#f0f9ff', padding: '12px', borderRadius: '6px', marginBottom: '20px' }}>
              <p style={{ margin: 0, fontSize: '12px', color: '#0369a1' }}>
                💡 <strong>Next:</strong> The client will receive an email with a secure registration link to set up their portal access.
              </p>
            </div>
            <button onClick={onClose} className="btn btn-primary">Done</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientInvitation;
